import React from 'react';
import AttendMngContainer from '../../containers/attendancemng/AttendMngContainer';

const AttendMngPage = () => {
  return <AttendMngContainer />;
};

export default AttendMngPage;
